import React from 'react'
import { makeStyles, Grid, Typography, Chip, Link } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#211A29',
    padding: '80px 20px',
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      padding: '80px 120px',
    },
  },
  header: {
    color: 'white',
    margin: '1rem 0',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '52px',
    },
  },
  chip: {
    background: 'rgba(11, 11, 11, 0.8)',
    color: 'white',
  },
  link: {
    color: 'white',
    fontSize: '.8rem',
    padding: '.4rem 0',
    borderBottom: '1px solid white',
  },
  contentSection: {
    margin: '1rem 0',
    '& p': {
      color: 'white',
    },
  },
  contentCard: {
    padding: '1rem',
    background: 'rgba(255, 255, 255, 0.06)',
    borderRadius: '.4rem',
  },
  cardBody: {
    fontSize: '1rem',
  },
  cardHeader: {
    margin: '0 0 1rem 0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
}))

export default function ExchangeGuide(): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Chip label="Exchange guide" className={classes.chip} />
      <Typography variant="h1" className={classes.header}>
        How to choose the right cryptocurrency exchange
      </Typography>
      <Link className={classes.link} underline="none">
        See the whole guide
      </Link>
      <div>
        <Grid container className={classes.contentSection} spacing={2} wrap="wrap">
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Ease of use
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                If you’re a crypto-trading beginner, look for a platform with a simple and
                straightforward interface. A good exchange starts simple, and hides complex features
                for advanced traders in the settings.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Payment methods
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                Make sure your exchange has deposit and withdrawal options that work for you, and
                remember to check the fees associated with different methods. Bank deposits are
                always the most inexpensive method, PayPal and credit cards are faster but more
                expensive.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Liquidity
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                The level of liquidity on an exchange affects the ease and speed with which you can
                complete trades. If there&apos;s a high level of liquidity – in other words, if the
                exchange has a high trading volume – then trades should be completed quickly and
                easily.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Fees
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                From deposit through to trading and then withdrawing funds, how much will it cost
                you to buy and sell crypto on each platform from start to finish? Good exchanges are
                transparent about their fees.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
